import React, { ChangeEvent, FC } from "react";
import { Box, Link, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { CONDITION_LINKCY_LINK, CONDITION_SAPHEER_LINK } from "../../config";
import { OfferChoise } from "./logic";
import styles from "./style";
import CustomCheckBox from "../Ui/CustomCheckBox";

interface ConditionProps {
  isSubmitted: boolean;
  setChoice: (data: OfferChoise) => void;
  choice: OfferChoise;
}

interface CheckboxItem {
  name: keyof OfferChoise;
  firstMessageId: string;
  secondMessageId: string;
  link: string;
}

const checkboxItems: CheckboxItem[] = [
  {
    name: "cgsSapheer",
    firstMessageId: "stepTwo.accept.first.cgsSapheer",
    secondMessageId: "stepTwo.accept.second.cgsSapheer",
    link: CONDITION_SAPHEER_LINK,
  },
  {
    name: "gtLinkcy",
    firstMessageId: "stepTwo.accept.first.gtLinkcy",
    secondMessageId: "stepTwo.accept.second.gtLinkcy",
    link: CONDITION_LINKCY_LINK,
  },
];

const Condition: FC<ConditionProps> = ({ isSubmitted, choice, setChoice }) => {
  const classes = styles();

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    setChoice({ ...choice, [e.target.name]: e.target.checked });
  };

  const handleOpen = (link: string) => {
    window.open(link, "_blank");
  };

  return (
    <Box marginBottom={1} marginTop={1}>
      {checkboxItems.map((item) => (
        <CustomCheckBox
          key={item.name}
          allPointer
          name={item.name}
          isSubmitted={isSubmitted}
          isChecked={!!choice[item.name]}
          onCheck={handleCheck}
          label={
            <Typography className={classes.text} align="left">
              <FormattedMessage id={item.firstMessageId} />
              <Link
                className={classes.link}
                onClick={() => handleOpen(item.link)}
              >
                {" "}
                <FormattedMessage id={item.secondMessageId} />
              </Link>
              .{" "}
              {isSubmitted && !choice[item.name] && (
                <Box color="error.main">
                  <FormattedMessage id="stepTwo.noCondition" />
                </Box>
              )}
            </Typography>
          }
        />
      ))}
    </Box>
  );
};

export default Condition;
